module.exports = __webpack_public_path__ + "img/rhodium.726eaca.jpg";